:host(.cat-time-menu) {
  nav {
    max-height: 16rem;
  }
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
